<template>
    <div>
        <img
            :key="i"
            :src="item"
            alt=""
            style="width: 100%; height:auto !important; margin: 5px;"
            v-for="(item,i) in images"/>
    </div>
</template>

<script>
    export default {
        name: "Project",
        props: ['thumbnail', 'terraces'],
        computed: {
            images() {
                let images = []
                this.terraces.map(terrace => {
                    images.push(terrace.visualisation.planks)
                    images.push(terrace.visualisation.plank_dimensions)
                    images.push(terrace.visualisation.joists)
                    images.push(terrace.visualisation.slats)
                    images.push(terrace.visualisation.draft_on)
                })
                return images
            }
        },
        data() {
            return {
                carousel: 0
            }
        }
    }
</script>

<style scoped>
    .thumbnail {
        cursor: pointer;
    }
</style>
